// extracted by mini-css-extract-plugin
export default {"DirectorWorkSection":"DirectorWork_DirectorWorkSection__fdsi0","DirectorWorkGalleryHolder":"DirectorWork_DirectorWorkGalleryHolder__CNEtK"};